import { createGlobalState } from 'react-hooks-global-state';
import { emptyDatesObject } from '../../availability_calendar/AvailabilityCalendar';

export const initialGlobalState = {
  // bookingsData: null,
  bookingId: null,
  bookingUserId: null,
  bookingTrialIssued: false,
  disabledDates: [],
  limitedDates: [],
  lakeDetails: [],
  bookingDates: [{ ...emptyDatesObject }],
  userSelectedPakage: null,
  inFlightArrivalDepartureRequests: 0,
  dateText: '',
  customPropertiesDetails: [],
  addedProductItem: [],
  productItem: [],
  lakeType: '',
  guestAllowed: '',
  isLakeExclusive: false,
  availableTime: null,
  arrivalTime: null,
  departureTime: null,
  isArrivalFixed: null,
  isDepartureFixed: null,
  swimAvailableData: null,
  unSelectableSwimIds: [],

  lakeInfoList: null,
  userSelectedLakeName: null,
  userSelectedLakeId: null,
  userSelectedSwims: [],
  userSelectedDoubleSwim: [],
  anglers: 10000,
  estimatedPricing: null,
  finalPricing: null,
  storedCards: [],
  storedCardsError: null,
  payableAmount: null,
  userInputSwimBookerId: null,
  maxRod: 3,
  howToBook: '',
  userDetails: null,
  userInfo: {},
  userInputDetails: {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
  },
  userInputLabel: ['First Name', 'Last Name', 'Email', 'Phone Number'],
  userInputName: ['first_name', 'last_name', 'email', 'phone_number'],
  userSelectedAnglers: 1,
  userSelectedRods: 0,
  lakeExclusive: false,
  userBookingData: {},
  ticketsAvailable: 20,
  accommodation: false,
  lakeInfo: null,
  fisheryInfo: null,
  bookingsLoading: false,
  current: 0,
  reservationExpiryTime: null,
  paymentError: null,
  paymentFormData: null,
  paymentSuccessRedirect: null,

  bookingOverlay: true,
  bookingType: '',
  isInsideWidget: false,
};
export const { GlobalStateProvider, setGlobalState, useGlobalState } =
  createGlobalState(initialGlobalState);
